// extracted by mini-css-extract-plugin
export default {"card":"IconCard_card__Sm2fC","container":"IconCard_container__yPZGd","image":"IconCard_image__PCKci","title":"IconCard_title__ATBF7"};